import { render, staticRenderFns } from "./SchoolSystemConfigDialog.vue?vue&type=template&id=4ce7bff8&scoped=true"
import script from "./SchoolSystemConfigDialog.vue?vue&type=script&lang=js"
export * from "./SchoolSystemConfigDialog.vue?vue&type=script&lang=js"
import style0 from "./SchoolSystemConfigDialog.vue?vue&type=style&index=0&id=4ce7bff8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce7bff8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ce7bff8')) {
      api.createRecord('4ce7bff8', component.options)
    } else {
      api.reload('4ce7bff8', component.options)
    }
    module.hot.accept("./SchoolSystemConfigDialog.vue?vue&type=template&id=4ce7bff8&scoped=true", function () {
      api.rerender('4ce7bff8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/systemconfig/SchoolSystemConfigDialog.vue"
export default component.exports